import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';

const CouponTable = ({
  displayCoupons,
  displayTotal,
  loading,
  lazyParams,
  setLazyParams,
  showAllCoupons,
  setShowAllCoupons,
  hasGeneratedCoupons
}) => {
  return (
    <div className="flex-1 min-h-0 overflow-auto">
      <div className="bg-white/80 backdrop-blur-sm rounded-xl border border-white/20 shadow-xl overflow-hidden flex flex-col flex-1 min-h-0">
        <div className="border-b border-gray-100 p-4 flex-shrink-0">
          <div className="flex justify-between items-center">
            <h3 className="text-2xl font-bold text-gray-900">
              {showAllCoupons ? 'All Coupons' : hasGeneratedCoupons ? 'Newly Generated Coupons' : 'Previous Coupons'}
            </h3>
            <div className="flex items-center gap-4">
              {displayTotal > 0 ? (
                <span className="flex items-center px-3 py-1 bg-green-50 text-green-700 rounded-full border border-green-200 text-sm">
                  <i className="pi pi-check-circle mr-2"></i>
                  {displayCoupons.length} of {displayTotal} coupons
                </span>
              ) : (
                <span className="flex items-center px-3 py-1 bg-orange-50 text-orange-700 rounded-full border border-orange-200 text-sm">
                  <i className="pi pi-exclamation-triangle mr-2"></i>
                  No coupons found
                </span>
              )}

              {hasGeneratedCoupons && (
                <button onClick={() => {
                  setShowAllCoupons(!showAllCoupons);
                  setLazyParams((p) => ({ ...p, first: 0 }));
                }}
                  className={`px-3 py-1 rounded-lg text-sm font-semibold transition-all ${showAllCoupons
                      ? 'bg-blue-600 text-white hover:bg-blue-700'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                    }`}
                >
                  <i className={`pi mr-1 ${showAllCoupons ? 'pi-eye-slash' : 'pi-eye'}`}></i>
                  {showAllCoupons ? 'Show Newly Generated' : 'Show All'}
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="p-4 overflow-y-auto flex-1 min-h-0">
          {loading ? (
            <div className="flex justify-center items-center py-12">
              <div className="flex flex-col items-center space-y-4">
                <div className="relative">
                  <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <i className="pi pi-ticket text-blue-600 text-xl"></i>
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  <span className="text-lg font-bold text-gray-900">Loading Coupons</span>
                  <span className="text-sm text-gray-500 italic">Please wait while we fetch the directory...</span>
                </div>
              </div>
            </div>
          ) : (
            <DataTable value={displayCoupons} paginator rows={lazyParams.rows} first={lazyParams.first} onPage={(e) => setLazyParams((p) => ({ ...p, first: e.first, rows: e.rows }))}
              rowsPerPageOptions={[5, 8, 10]} responsiveLayout="scroll" emptyMessage="No coupons found" className="p-datatable-striped p-datatable-gridlines text-xs" size="small">
              <Column field="code" header="Coupon Code" style={{ minWidth: '120px' }} />
              <Column field="feeType" header="Fee Type" style={{ minWidth: '100px' }} />
              <Column field="discountPct" header="Discount" style={{ minWidth: '80px' }}
                body={(r) => (
                  <Badge value={r.discountPct ? `${r.discountPct}%` : '-'} severity="info" />
                )}
              />
              <Column field="used" header="Used" style={{ minWidth: '70px' }}
                body={(r) => (
                  <Badge value={r.used ? 'Yes' : 'No'} severity={r.used ? 'success' : 'warning'} />
                )} />
              <Column field="createdAt" header="Created" body={(r) => r.createdAt ? new Date(r.createdAt).toLocaleString() : '-'} style={{ minWidth: '140px' }} />
            </DataTable>
          )}
        </div>
      </div>
    </div>
  );
};

export default CouponTable;
